import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Mountain } from "lucide-react";

interface IValleyType {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function ValleyType(props: IValleyType) {
    const { value, onChange, loading } = { ...props };
    const [valleyType, setValleyType] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setValleyType(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setValleyType(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Valley Type
            </Typography>

            <Select
                placeholder="Select valley type"
                value={valleyType}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Mountain size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="Closed Valley">Closed Valley</Option>
                <Option value="Open (W) Valley">Open (W) Valley</Option>
            </Select>
        </Box>
    );
}
